import { render, staticRenderFns } from "./ChatbotModal.vue?vue&type=template&id=e406283e&scoped=true&"
import script from "./ChatbotModal.vue?vue&type=script&lang=js&"
export * from "./ChatbotModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotModal.vue?vue&type=style&index=0&id=e406283e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e406283e",
  null
  
)

export default component.exports